import { NavigationEventData } from '../../types/navigation-tracking';
import { SessionManager } from './SessionManager';
import { NavigationBatcher } from './NavigationBatcher';

export class NavigationTracker {
  private sessionManager: SessionManager;
  private batcher: NavigationBatcher;
  private lastPath: string | null = null;
  private lastTimestamp: number | null = null;
  private userId: string | null = null;

  constructor() {
    this.sessionManager = new SessionManager();
    this.batcher = new NavigationBatcher();
  }

  setUserId(userId: string): void {
    this.userId = userId;
  }

  track(path: string): void {
    if (!this.userId) return;

    const now = Date.now();
    const timeOnPreviousPage = this.lastTimestamp ? now - this.lastTimestamp : undefined;

    const event: NavigationEventData = {
      sessionId: this.sessionManager.getSessionId(),
      timestamp: new Date(now).toISOString(),
      from: this.lastPath,
      to: path,
      action: this.lastPath === null ? 'INITIAL' : 'PUSH',
      timeOnPreviousPage,
      referrer: document.referrer,
      userAgent: navigator.userAgent,
      screenSize: {
        width: window.screen.width,
        height: window.screen.height,
      },
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight,
      },
    };

    this.batcher.add(event);
    this.lastPath = path;
    this.lastTimestamp = now;
  }

  reset(): void {
    this.batcher.flush();
    this.sessionManager.reset();
    this.userId = null;
    this.lastPath = null;
    this.lastTimestamp = null;
  }

  destroy(): void {
    this.batcher.destroy();
  }
}
